import angular from 'angular'

const iFrameTempModule = angular
    .module('app.iFrameTemp', [])

export default iFrameTempModule.name
/**
 * key: id
 * css: 宽度
 */
iFrameTempModule.component('iframeTemplate', {
    template: '<iframe ng-src="{{$ctrl.pathUrl}}" frameborder="0" id="{{$ctrl.key}}" scrolling="no" width="{{$ctrl.css}}" name="{{$ctrl.key}}"></iframe>',
    bindings: {
        pathUrl: '@',
        key: '@',
        css: '@',
    },
    controller: ['$scope', '$timeout', function ($scope, $timeout) {
        this.$onInit = function () {
            const id = this.key
            $timeout(() => {
                const ifm = document.getElementById(id)
                const changeFrameHeight = function () {
                    ifm.height = document.documentElement.clientHeight
                }
                window.onresize = changeFrameHeight
                changeFrameHeight()
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/components/iFrameTemp/index.js